// extracted by mini-css-extract-plugin
export default {"root":"NOfjpp","multiple":"AAiaHT","column":"NXZfSm","main":"KthAtp","info":"Ta9uZV"};